// extracted by mini-css-extract-plugin
var _1 = "gguxfeiuCexEUldGGbOx";
export { _1 as "root" }
